/**
 * Core foundation layer: provides constants, state management, basic DOM utilities,
 * and response UI. This is the base infrastructure that other modules depend on.
 */
(function () {
  "use strict";

  window.BoaBranchPicker = window.BoaBranchPicker || {};

  // ============================================================================
  // Constants
  // ============================================================================
  window.BoaBranchPicker.constants = {
    MODAL_ID: "boa-branch-picker",
    STEP_SELECTOR: `.boa-branch-picker__step`,
    INITIAL_STEP: `.boa-branch-picker__step--initial`,
    DATE_STEP: `.boa-branch-picker__step--date-selection`,
    STEP_SELECTORS: {
      initial: `.boa-branch-picker__step--initial`,
      "date-selection": `.boa-branch-picker__step--date-selection`,
    },
    SELECTORS: {
      customSelect: "[data-custom-select]",
      searchableSelect: "[data-searchable-select]",
      customTrigger: ".boa-custom-select__trigger",
      searchableTrigger: ".boa-searchable-select__trigger",
      customHiddenInput: "input[type='hidden'][data-custom-select-input]",
      searchableHiddenInput:
        "input[type='hidden'][data-searchable-select-input]",
      customValue: ".boa-custom-select__value",
      searchableValue: ".boa-searchable-select__value",
      customDropdown: ".boa-custom-select__dropdown",
      customOption: ".boa-custom-select__option",
      searchableOption: ".boa-searchable-select__option",
      searchInput: "[data-search-input]",
      searchResults: "[data-search-results]",
      dateOption: "[data-date-option]",
      optionSpecificFields: ".boa-branch-picker__option-specific-fields",
      addressFields: "[data-address-type]",
      recipientType: "[data-recipient-type]",
    },
    IDS: {
      departmentSelect: "boa-delivery-department-select",
      cityInput: "boa-delivery-city",
      streetInput: "boa-delivery-street",
      houseNumberInput: "boa-delivery-house-number",
      hospitalInput: "boa-delivery-hospital",
      regionMetaobjectId: "boa-pickup-region-metaobject-id",
      branchMetaobjectId: "boa-pickup-branch-metaobject-id",
    },
  };

  // ============================================================================
  // State
  // ============================================================================
  let selectedDeliveryMethod = null;
  let datePickerInstance = null;

  window.BoaBranchPicker.state = {
    getSelectedDeliveryMethod: function () {
      return selectedDeliveryMethod;
    },
    setSelectedDeliveryMethod: function (value) {
      selectedDeliveryMethod = value;
    },
    getDatePickerInstance: function () {
      return datePickerInstance;
    },
    setDatePickerInstance: function (value) {
      datePickerInstance = value;
    },
  };

  // ============================================================================
  // DOM Utils
  // ============================================================================
  const constants = window.BoaBranchPicker.constants;

  window.BoaBranchPicker.domUtils = {
    getInputElement: function (id) {
      const element = document.getElementById(id);
      return element instanceof HTMLInputElement ? element : null;
    },

    getModal: function () {
      return document.getElementById(constants.MODAL_ID);
    },

    getResponseElement: function () {
      const modal = this.getModal();
      return modal?.querySelector(".boa-branch-picker__response");
    },

    isCustomSelect: function (select) {
      return select.hasAttribute("data-custom-select");
    },

    getSelectTriggerSelector: function (select) {
      return this.isCustomSelect(select)
        ? constants.SELECTORS.customTrigger
        : constants.SELECTORS.searchableTrigger;
    },
  };

  // ============================================================================
  // Response UI
  // ============================================================================
  const domUtils = window.BoaBranchPicker.domUtils;

  window.BoaBranchPicker.responseUI = {
    showResponseLoading: function () {
      const responseEl = domUtils.getResponseElement();
      if (!responseEl) return;

      responseEl.classList.remove(
        "boa-branch-picker__response--hidden",
        "is-success",
        "is-error"
      );
      responseEl.classList.add("is-loading");
    },

    showResponseSuccess: function () {
      const responseEl = domUtils.getResponseElement();
      if (!responseEl) return;

      const messageEl = responseEl.querySelector(
        ".boa-branch-picker__response-message"
      );
      if (messageEl) {
        messageEl.textContent = "";
      }

      responseEl.classList.remove(
        "boa-branch-picker__response--hidden",
        "is-loading",
        "is-error"
      );
      responseEl.classList.add("is-success");

      setTimeout(() => {
        domUtils.getModal()?.removeAttribute("open");
      }, 1500);
    },

    showResponseError: function (message) {
      const responseEl = domUtils.getResponseElement();
      if (!responseEl) return;

      const messageEl = responseEl.querySelector(
        ".boa-branch-picker__response-message"
      );
      if (messageEl) {
        messageEl.textContent = message || "";
      }

      responseEl.classList.remove(
        "boa-branch-picker__response--hidden",
        "is-loading",
        "is-success"
      );
      responseEl.classList.add("is-error");
    },

    hideResponseUI: function () {
      const responseEl = domUtils.getResponseElement();
      if (!responseEl) return;

      responseEl.classList.add("boa-branch-picker__response--hidden");
      responseEl.classList.remove("is-loading", "is-success", "is-error");

      const messageEl = responseEl.querySelector(
        ".boa-branch-picker__response-message"
      );
      if (messageEl) {
        messageEl.textContent = "";
      }
    },
  };

  // Dispatch ready event
  document.dispatchEvent(new CustomEvent("boa-branch-picker:core-ready"));
})();
